module.exports = __webpack_public_path__ + "img/home-process-3.5b1df2d7.png";